import React from "react";

const Spinner = ({ size = "md", className = "" }) => {
    const sizes = {
        sm: "h-4 w-4",
        md: "h-5 w-5",
        lg: "h-6 w-6",
    };
    
    return (
        <svg
            className={`animate-spin ${sizes[size]} ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
        </svg>
    );
};

const Button = ({
    children,
    variant = "primary",
    size = "md",
    isLoading = false,
    disabled = false,
    type = "button",
    onClick,
    className = "",
    icon,
    iconPosition = "left",
    fullWidth = false,
    ...props
}) => {
    const baseClasses = "inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed touch-manipulation";
    
    const variants = {
        primary: "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-600",
        secondary: "bg-slate-200 text-slate-900 hover:bg-slate-300 focus:ring-slate-500 dark:bg-slate-700 dark:text-slate-100 dark:hover:bg-slate-600",
        outline: "border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 focus:ring-indigo-500 dark:border-indigo-400 dark:text-indigo-400 dark:hover:bg-indigo-900/20",
        ghost: "text-slate-700 hover:bg-slate-100 focus:ring-slate-500 dark:text-slate-300 dark:hover:bg-slate-800",
        danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 dark:bg-red-500 dark:hover:bg-red-600",
        success: "bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-500 dark:bg-emerald-500 dark:hover:bg-emerald-600",
    };
    
    const sizes = {
        sm: "px-3 py-1.5 text-sm",
        md: "px-4 py-2 text-base",
        lg: "px-6 py-3 text-lg",
    };
    
    const widthClass = fullWidth ? "w-full" : "";
    
    const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
    
    const isDisabled = disabled || isLoading;
    
                return (
                    <button
                        type={type}
                        onClick={onClick}
                        disabled={isDisabled}
                        className={classes}
                        aria-busy={isLoading}
                        aria-disabled={isDisabled}
                        {...props}
                    >
            {isLoading ? (
                <>
                    <Spinner size="sm" className="mr-2" />
                    <span>Loading...</span>
                </>
            ) : (
                <>
                    {icon && iconPosition === "left" && <span className="mr-2">{icon}</span>}
                    {children}
                    {icon && iconPosition === "right" && <span className="ml-2">{icon}</span>}
                </>
            )}
        </button>
    );
};

export default Button;
